import React from 'react';
import './BeforeAfter.css';
import { X, ArrowRight, Check } from 'lucide-react';

function BeforeAfter() {
  return (
    <section className='before-after'>
      <div className='before-after-container'>
        <h2 className='section-title'>
          The Real Reason You're Stuck at 37 Subscribers
        </h2>

        <div className='comparison-grid'>
          {/* BEFORE */}
          <div className='comparison-card before'>
            <div className='card-header'>
              <X size={24} className='icon-before' />
              <h3>Without Repost</h3>
            </div>
            <ul className='comparison-list'>
              <li>Great content buried in inboxes</li>
              <li>3-4 hours weekly reformatting for each platform</li>
              <li>LinkedIn ≠ Twitter ≠ Instagram = exhausting</li>
              <li>Skip social posting when tired = zero discovery</li>
              <li>6 months later: still under 100 subscribers</li>
            </ul>
            <div className='time-badge'>15+ hours/month wasted</div>
          </div>

          {/* ARROW */}
          <div className='arrow-divider'>
            <ArrowRight size={32} />
          </div>

          {/* AFTER */}
          <div className='comparison-card after'>
            <div className='card-header'>
              <Check size={24} className='icon-after' />
              <h3>With Repost</h3>
            </div>
            <ul className='comparison-list'>
              <li>One newsletter → 6+ platform-native posts</li>
              <li>LinkedIn, Twitter, Instagram - all optimized</li>
              <li>Post everywhere your readers actually are</li>
              <li>Turn newsletters into discovery engines</li>
              <li>Consistent growth without manual work</li>
            </ul>
            <div className='time-badge success'>90 seconds total</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BeforeAfter;
